export const ANIMATION_TYPES = {
  DELETE: 'delete',
  ADD: 'add',
};
